import {
  type IdentityVerificationExportsModel,
  IdentityVerificationExportsModelAggregateStatus,
} from '@urbanx/agx.campaigns.client'
import {
  AgxIdentityVerificationExports,
  AgxSpacer,
} from '@urbanx/agx.ui-components2'

interface Props {
  id: string
  campaignId: string
  validate: boolean
  value?: IdentityVerificationExportsModel
}

const IdentityVerificationExportsElement = ({
  id,
  campaignId,
  validate,
  value,
}: Props) => {
  const hasIncompleteExports =
    validate &&
    value?.aggregateStatus === IdentityVerificationExportsModelAggregateStatus.Incomplete

  return (
    <>
      <AgxIdentityVerificationExports
        id={id}
        campaignId={campaignId}
        mode="vendors"
      />
      {hasIncompleteExports && (
        <AgxSpacer
          id={`${id}-aggregate-status-error`}
          direction="horizontal"
          fill
          className="error"
          hidden
        />
      )}
    </>
  )
}

export default IdentityVerificationExportsElement
